import { createReducer, on } from "@ngrx/store";
import { UserPreferenceActions } from "../actions";
import { Preference } from "../models/Preference";
import { PreferenceTab } from "../models/PreferenceTab";

export const userPreferencesKey = "tablePreferences";

export interface State extends UserPreferenceList { }

interface UserPreferenceList {
  tabs: UserPreferenceById;
  preferencesLoaded: boolean;
  serviceError: boolean;
}

export const initialUserPreferenceState: State = {
  tabs: {},
  preferencesLoaded: false,
  serviceError: false
}

export interface UserPreferenceById {
  [tabName: string]: PreferenceTab
}

export const userPreferenceReducer = createReducer(
  initialUserPreferenceState,
  on(UserPreferenceActions.loadPreferencesSuccess, (state, response) => {
    return {
      ...state,
      preferencesLoaded: true,
      tabs: {
        ...state.tabs,
        ...updateTableTabPreferences(state.tabs, ParseTableTabPreferenceJson(response.userPreferenceResponse))
      }
    }
  }),
  on(UserPreferenceActions.savePreferencesSuccess, (state, update) => {
    return {
      ...state,
      tabs: {
        ...state.tabs,
        ...updateTableTabPreferences(state.tabs, ParseTableTabPreferenceJson(update.userPreferenceResponse))
      }
    }
  }),
  on(UserPreferenceActions.savePreferencesFailure, (state, err) => {
    return {
      ...state,
      serviceError: true,
    };
  }),
  on(UserPreferenceActions.loadPreferencesFailure, (state, err) => {
    return {
      ...state,
      serviceError: true,
    };
  }),
)

function ParseTableTabPreferenceJson(preferences: Preference[]): PreferenceTab[] {
  let preferenceArray: PreferenceTab[] = [];
  preferences.forEach(preference => {
    let tab: PreferenceTab = {
      tabName: '',
      tableName: '',
      columns: []
    };
    if (!preference?.preferenceName?.includes('-')) {
      return;
    }
    let parts = preference.preferenceName.split('-');

    tab.tableName = parts[0] ?? 'NO TABLE';
    tab.tabName = parts[1] ?? 'NO TAB';
    try {
      tab.columns = JSON.parse(preference.preferenceValue);
      const tabs = ['all', 'recent', 'recurring', 'upcoming']
      if (tab.tableName == 'transactions' && tabs.some(i => i.includes(tab.tabName))) {
        tab.columns.forEach(col => {
          if (col.colId == "Incoming\/Outgoing") {
            col.colId = "Direction"
          }
        });
      }
    } catch {

    }
    preferenceArray.push(tab);
  });
  return preferenceArray;
}

function updateTableTabPreferences(toBeUpdated: UserPreferenceById, updates: PreferenceTab[]): UserPreferenceById {
  let byId: UserPreferenceById = {};

  updates?.forEach(update => {
    byId[update.tableName + '-' + update.tabName] = { ...toBeUpdated[update.tableName + '-' + update.tabName], ...update };
  })

  return byId;
}
